import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input,TreeSelect } from 'antd'

import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class PositionTypePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
    const {getAllPositionType} = this.props.actions;
     const { positionTypePage,currentPositionType} = this.props.system;
     getAllPositionType();
     this.fetchList( positionTypePage);
  }

  fetchList = (page,values) => {
    const {getPositionTypeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getPositionTypeList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { positionTypeById, positionTypeList } = system;
    if (!positionTypeList) return [];
    return positionTypeList.map(id => positionTypeById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getPositionTypeListPending,positionTypeTotal,positionTypePage,allTypeById,originPositionTypeTree } = system
    const { deletePositionType,chooseCurrentPositionType,positionTypeModalChange } = actions;

    return {
      dataSource: originPositionTypeTree,
      loading: getPositionTypeListPending,
      columns:[
        {
            title: "名称",
            dataIndex: 'typeName',
            key: 'typeName',
            align:'left',
            width: 180,
          },
          {
            title: "排序号",
            dataIndex: 'orderNum',
            key: 'orderNum',
            align:'left',
            width: 180,
          },
        //   {
        //     title: "父级",
        //     dataIndex: 'pid',
        //     key: 'pid',
        //     width: 180,
        //     render: text => {
        //       if (text == -1){
        //         return <span></span>
        //       }else{
        //         let item = allTypeById[text];
        //         if (item != undefined){
        //           return  <span>{item.typeName}</span>
        //         }
        //       }
             
        //     },
        //   },
      ],
      pagination:null,
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        }
        // {
        //   key:3,
        //   name:'删除',
        //   buttonProps:{
        //     icon:"delete",
        //     type:"danger"
        //   },
        //   needConfirm:true,
        //   confirmTitle:"确认删除"
        // }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentPositionType(record);
          positionTypeModalChange(true,"updata");
        }else if(item.key == 3){
            deletePositionType(record.id).then((data) => {
            this.fetchList(positionTypePage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { system,actions } = this.props
    const { currentPositionType, positionTypeModalVisible,positionTypePage, positionTypeModalType,submitPositionTypePending,positionTypeTree } = system

    const { positionTypeModalChange,submitPositionType } = actions;
    const editItem  = positionTypeModalType === 'create' ? {} : currentPositionType
    return {
      item: positionTypeModalType === 'create' ? {} : currentPositionType,
      visible: positionTypeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitPositionTypePending,
      title: `${
        positionTypeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
            key: "pid",
            label: "父级",
            initialValue: editItem.pid,
            widget: TreeSelect,
            widgetProps:{
              treeData:positionTypeTree,
              treeDefaultExpandAll:false,
              onChange:this.onChange,
            },
            required: false
          },
          {
            key: "typeName",
            label: "名称",
            initialValue: editItem.typeName,
            widget: Input,
            required: true
          },
          {
            key: "orderNum",
            label: "排序号",
            initialValue: editItem.orderNum,
            widget: Input,
            required: true
          },
      ],
      onOk: data => {
        submitPositionType(Object.assign({},data,{})).then(data=> {
          positionTypeModalChange(false,"create");
          this.fetchList(positionTypePage);
        })
      },
      onCancel() {
        positionTypeModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentPositionType,positionTypePage} = system
    const { positionTypeModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "typeName",
            widget: Input,
            widgetProps:{
                placeholder:"请输入名称"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        positionTypeModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentPositionType,positionTypePage} = system
    const { positionTypeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ positionTypeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        {/* <CrudFilter {...this.filterProps} /> */}
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PositionTypePage);


// WEBPACK FOOTER //
// ./src/features/system/PositionTypePage.js